// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAcaDY3Ky89gPgVcf_nrkTUhSxrfuX62Z0",
    authDomain: "zimonfamily-42191.firebaseapp.com",
    databaseURL: "https://zimonfamily-42191.firebaseio.com",
    projectId: "zimonfamily-42191",
    storageBucket: "zimonfamily-42191.appspot.com",
    messagingSenderId: "429865020972",
    appId: "1:429865020972:web:65f34f3888aa7b00456b89",
    measurementId: "G-XC5PBYMH4V"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
